// extracted by mini-css-extract-plugin
module.exports = {"container":"Footer_container__3pD6f","footer":"Footer_footer__fIHO2"};